import classNames from 'classnames';
import React from 'react';

import { InfoCard } from '@eika/card';
import { Link, LinkType } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

type NoAccountsCardProps = {
    className?: string;
};

const NoAccountsCards: React.FC<NoAccountsCardProps> = ({ className }) => {
    const translated = useTranslation();
    const { createAccountsLink, featureToggles } = useConfig();
    return (
        <InfoCard className={classNames('sgw-layout-item', className)} skipBackground>
            <RichIcon type={RichIconTypes.SOMMERFUGLER} />
            <InfoCard.TitleH2>{translated.accountsList.noAccountsHeader}</InfoCard.TitleH2>
            {createAccountsLink && !featureToggles.disableAccountCreation ? (
                <>
                    {translated.accountsList.noAccountsDescriptionWithButton}
                    <div style={{ marginTop: 24 }} className="create-account__wrapper">
                        <Link linkType={LinkType.BUTTON_STANDARD_POSITIVE} href={createAccountsLink?.url}>
                            {createAccountsLink.text ?? translated.accountsList.createAccount}
                        </Link>
                    </div>
                </>
            ) : (
                <>{translated.accountsList.noAccountsDescription}</>
            )}
        </InfoCard>
    );
};
export default NoAccountsCards;
